import React, { Fragment, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import styles from "./InnerNavbar.module.scss";

import ChevronDown from "assets/icons/chevron-down.svg";
import ChevronUp from "assets/icons/chevron-up.svg";

const handleClick = () => {
    const currentScrollY = window.scrollY;

    requestAnimationFrame(() => {
        window.scrollTo(0, currentScrollY);
    });
};

const NavigationLink = ({ to, label }) => {
    return (
        <NavLink
            className={`${styles.navLink} mx-xl-4 mx-lg-3`}
            activeClassName={styles.activeNavLink}
            to={to}
            onClick={handleClick}
        >
            <p className="gkit-p-17 m-0">{label}</p>
        </NavLink>
    );
};

const AccordionLink = ({ to, label, hash, Router, isOpen, onToggle }) => {
    const Content = () => (
        <div
            id={hash}
            className={`${styles.accordionLink} ${
                isOpen ? styles.activeNavLink : ""
            } border-end border-start border-bottom border-top justify-content-between`}
            onClick={onToggle}
        >
            <p className="gkit-p-17">{label}</p>
            {isOpen ? (
                <img src={ChevronUp} alt="Chevron up" width={16} height={16} />
            ) : (
                <img
                    src={ChevronDown}
                    alt="Chevron down"
                    width={16}
                    height={16}
                />
            )}
        </div>
    );

    return (
        <Fragment>
            <HashLink
                to={`${to}#${hash}`}
                onClick={handleClick}
                scroll={(el) =>
                    el.scrollIntoView({ behavior: "auto", block: "nearest" })
                }
            >
                <Content />
            </HashLink>

            {isOpen && (
                <div className="p-3">
                    <Router />
                </div>
            )}
        </Fragment>
    );
};

const InnerNavbar = ({ tabs, Router = null }) => {
    const location = useLocation();

    const [openTabHash, setOpenTabHash] = useState(
        location.pathname.includes("/plan") ? "plan" : null,
    );

    const handleToggle = (hash) => {
        setOpenTabHash((prevHash) => (prevHash === hash ? null : hash));
    };
    return (
        <Fragment>
            <div className={`d-none d-md-flex ${styles.navbar}`}>
                {tabs.map((tab) => (
                    <NavigationLink {...tab} key={tab.label} />
                ))}
            </div>
            <div className={`d-block d-md-none ${styles.accordionNav}`}>
                {tabs.map((tab) => (
                    <AccordionLink
                        {...tab}
                        key={tab.label}
                        Router={Router}
                        isOpen={openTabHash === tab.hash}
                        onToggle={() => handleToggle(tab.hash)}
                    />
                ))}
            </div>
        </Fragment>
    );
};

export default InnerNavbar;
